export const initalMentionState = [
  { id: 1, value: "First name" },
  { id: 2, value: "Last name" },
];
